<ionic-selectable
  *ngIf="(projects$ | async)?.loading === false"
  [(ngModel)]="projectId"
  [items]="(projects$ | async)?.data || []"
  itemValueField="id"
  itemTextField="name"
  [canSearch]="true"
  [hasInfiniteScroll]="true"
  [shouldStoreItemValue]="true"
  (onInfiniteScroll)="getMoreProjects($event)"
  (onOpen)="onOpen($event, true)"
  (onSearch)="searchProjects($event)"
  closeButtonSlot="end"
  #projectSelectComponent
>
  <ng-template ionicSelectablePlaceholderTemplate>
    Project
  </ng-template>
  <ng-template ionicSelectableFooterTemplate>
    <ion-toolbar>
      <ion-row>
        <ion-col>
          <ion-button expand="full" (click)="create()" [disabled]="(access$ | async) === false">
            Create Project
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="full" (click)="selectProject()">
            {{projectId ? 'Change Project' : 'confirm'}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-toolbar>
  </ng-template>
</ionic-selectable>

<ion-spinner name="dots" *ngIf="(projects$ | async)?.loading"></ion-spinner>
